<template>
  <div class="submittask-cnt">
    <header class="inner-head">
      <span class="icon-Btn" @click="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
          <path
            d="M7.993 14.119c.395.432.4 1.127.007 1.558-.39.429-1.019.434-1.418-.004L.297 8.779c-.393-.43-.4-1.122 0-1.56L6.582.326C6.975-.105 7.607-.11 8 .32c.39.428.392 1.121-.007 1.559L3.414 6.902h13.584C17.55 6.902 18 7.39 18 8c0 .606-.452 1.097-1.002 1.097H3.414l4.58 5.023z"
          />
        </svg>
      </span>

      <h2>{{$t('submitYourTask')}}</h2>
    </header>

    <section class="mid-cnt">
      <div class="fomr-box">
        <div class="field-row">
          <label class="text-label">{{$t('addATitle')}}</label>
          <input class="input-style" :placeholder="$t('writeTaskTitle')" v-model="title" />

          <div class="upload-data">
            <AddTaskVideo @uploadImageList="previewPhoto" :previousImages="checkOrderDetail()" />
          </div>
        </div>

        <!-- <div class="field-row">
          <label class="text-label">
            {{$t('comments')}}
            <span>({{$t('optional')}})</span>
          </label>
          <textarea class="textare-style" :placeholder="$t('writeHere')" v-model="comments"></textarea>
        </div>-->
      </div>
    </section>

    <footer class="footer-bottom" @click="acceptModalfunc()">
      <button class="button">{{$t('submitYourTask')}}</button>
    </footer>
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="customModal" v-if="acceptModal">
      <div class="modal_dialog">
        <div class="modal_content">
          <h3>{{$t('doYouReallyWantToSumbit')}}</h3>
        </div>
        <div class="modal_footer alert_btn">
            <button type="button" class="no" @click="acceptModal = !acceptModal">{{$t('later')}}</button>
            <button type="button" class="yes" @click="submitYourTask()">{{$t('yes')}}</button>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddTaskVideo from "../components/AddTaskVideo";
import "../assets/css/submit-task.css";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import CustomToaster from "../components/Common/CustomToaster";

export default {
  name: "SubmitTask",
  components: {
    AddTaskVideo,
    CustomToaster
  },
  data() {
    return {
      videoUrls: {
        urls: []
      },
      comments: "",
      title: "",
      isValidDetail: false,
      toasterData: {},
      loading: false,
      acceptModal: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    checkOrderDetail() {
      return this.videoUrls.urls == null ? [] : this.videoUrls.urls;
    },
    previewPhoto(photofile) {
      this.videoUrls.urls = photofile;
    },
    acceptModalfunc() {
      if (this.title && this.videoUrls.urls.length) {
        this.acceptModal = !this.acceptModal;
      } else {
        this.toasterData = {
          msg: this.$t("enterAllFeilds"),
          color: "#ff4643",
          iconName: "error"
        };
        this.isValidDetail = true;
      }
    },
    submitYourTask() {
      this.loading = true;
      const obj = {
        doc: this.videoUrls.urls,
        title: this.title,
        task_id: Number(this.$route.query.taskId)
      };
      ApiCaller(constant.BASE_API_URL, "tasks/complete_orders/", "post", obj)
        .then(data => {
          this.acceptModal = !this.acceptModal;
          this.loading = false;
          this.$router.replace("/upload-success/");
        })
        .catch(err => {
          this.loading = false;
          this.acceptModal = !this.acceptModal;
          this.toasterData = {
            msg: this.$t("notUpdatedYourTask"),
            color: "#ff4643",
            iconName: "error"
          };
          this.isValidDetail = true;
             setTimeout(() => {
              this.$router.replace("/");
            }, 2000);
          console.log(err);
        });
    }
  }
};
</script>